import script from "./CompanySingleView.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanySingleView.vue?vue&type=script&setup=true&lang=js"

import "./CompanySingleView.vue?vue&type=style&index=0&id=70a4b035&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70a4b035"]])

export default __exports__